import * as yup from 'yup';
import { API as users_nautica } from '../../users_nautica';
import { API as yachts } from '../../yachts/api';
import {
  DefaultStatusOpBooking,
  StatusOperationBC,
  StatusOperationBF,
  StatusOperationBookingType, AreaOptions, DefaultAreas,
  StatusBilling,
  DefaultStatusBilling
} from '../../operations/conf/Data.conf';
import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import isSameOrAfter from 'dayjs/plugin/isSameOrAfter';
import { API as provenanceList } from '../../provenenceLists/api';

dayjs.extend(utc);
dayjs.extend(isSameOrAfter);

export const FilterConf = {
  schema: yup.object({
    id_yacht: yup.array().nullable(),
    start_date: yup
      .mixed()
      .nullable()
      .transform((value) =>
        value && dayjs(value).isValid()
          ? dayjs(value).format('YYYY-MM-DDTHH:mm:ss')
          : null
      )
      .test('is-valid', 'Invalid date', function (value) {
        if (value) return !!dayjs(value).isValid();
        return true;
      }),
    end_date: yup
      .mixed()
      .nullable()
      .transform((value) =>
        value && dayjs(value).isValid()
          ? dayjs(value).format('YYYY-MM-DDTHH:mm:ss')
          : null
      )
      .test(
        'end-after-start',
        "End date can't be before Start date",
        function (value) {
          const { start_date } = this.parent;

          if (!value || !start_date) return true;
          return dayjs(value).isSameOrAfter(dayjs(start_date));
        }
      )
      .test('is-valid', 'Invalid date', function (value) {
        if (value) return !!dayjs(value).isValid();
        return true;
      }),
    id_user_provision: yup.array().nullable(),
    provenance: yup.array().nullable(),
    area: yup.array().nullable(),
    status_billing: yup.array().nullable(),
  }),
  initialState: {
    value: {
      id_yacht: null,
      id_user_in_charge: [],
      start_date: dayjs.utc().startOf('year').format('YYYY-MM-DD').toString(),
      end_date: dayjs.utc().endOf('year').format('YYYY-MM-DD').toString(),
      status_operation_booking: DefaultStatusOpBooking,
      status_billing: DefaultStatusBilling,
      status_operation_BC: null,
      status_operation_BF: null,
      id_user_provision: [],
      provenance: null,
      area: DefaultAreas,
    },
  },
  fields: [
    {
      id: 'id_yacht',
      name: 'id_yacht',
      type: 'async_autocomplete_multiple',
      label: 'Yacht',
      api: yachts.selectNoDRAFT,
      required: false,
      xs: 12,
      sm: 6,
      md: 4,
    },
    {
      id: 'id_user_in_charge',
      name: 'id_user_in_charge',
      type: 'async_autocomplete_multiple',
      label: 'Operation Person in Charge',
      api: users_nautica.selectName,
      required: false,
      xs: 12,
      sm: 6,
      md: 4,
    },
    {
      id: 'id_user_provision',
      name: 'id_user_provision',
      type: 'async_autocomplete_multiple',
      label: 'Sales Agent',
      api: users_nautica.selectName,
      required: false,
      xs: 12,
      sm: 6,
      md: 4,
    },
    {
      id: 'status_operation_booking',
      name: 'status_operation_booking',
      type: 'autocomplete_multiple',
      label: 'Status Operation Booking',
      options: StatusOperationBookingType,
      required: false,
      xs: 12,
      sm: 6,
      md: 4,
    },
    {
      id: 'start_date',
      name: 'start_date',
      type: 'date',
      label: 'Start Date',
      required: false,
      xs: 12,
      sm: 6,
      md: 4,
    },
    {
      id: 'end_date',
      name: 'end_date',
      type: 'date',
      label: 'End Date',
      required: false,
      xs: 12,
      sm: 6,
      md: 4,
    },
    {
      id: 'status_operation_BC',
      name: 'status_operation_BC',
      type: 'autocomplete',
      label: 'Status Sales Order',
      options: StatusOperationBC,
      required: false,
      xs: 12,
      sm: 6,
      md: 4,
    },
    {
      id: 'status_operation_BF',
      name: 'status_operation_BF',
      type: 'autocomplete',
      label: 'Status Purchase Order',
      options: StatusOperationBF,
      required: false,
      xs: 12,
      sm: 6,
      md: 4,
    },
    {
      id: 'status_billing',
      name: 'status_billing',
      type: 'autocomplete_multiple',
      label: 'Billing Status',
      options: StatusBilling,
      required: false,
      xs: 12,
      sm: 6,
      md: 4,
    },
    {
      id: 'provenance',
      name: 'provenance',
      type: 'async_autocomplete_multiple',
      label: 'Provenance',
      api: provenanceList.provenences,
      required: false,
      xs: 12,
      sm: 6,
      md: 4,
    },
    {
      id: 'area',
      name: 'area',
      type: 'autocomplete_multiple',
      label: 'Area',
      options: AreaOptions,
      required: false,
      xs: 12,
      sm: 6,
      md: 4,
    },
  ],
  query: {
    keys: [
      {
        key: 'id_yacht.id',
        value: 'id_yacht.id',
        operator: '$eq',
      },

      {
        key: 'id_yacht.id_attendance.id_agent_NA.id',
        value: 'id_agent_NA.id',
        operator: '$eq',
      },
      {
        key: 'id_yacht.id',
        value: 'id_yacht.id',
        operator: '$eq',
      },
      {
        key: 'id_reservation.reservation_type',
        value: 'id_reservation.id',
        operator: '$eq',
      },
      {
        key: 'id_user_in_charge.id',
        value: 'id_user_in_charge.id',
        operator: '$eq',
      },
      {
        key: 'requested_date',
        value: 'start_date',
        operator: '$gte',
      },
      {
        key: 'requested_date',
        value: 'end_date',
        operator: '$lte',
      },
      {
        key: 'status_operation_booking',
        value: 'status_operation_booking.label',
        operator: '$eq',
      },
      {
        key: 'status_operation_BC',
        value: 'status_operation_BC.label',
        operator: '$eq',
      },
      {
        key: 'status_operation_booking',
        value: 'status_operation_booking.label',
        operator: '$eq',
      },
      {
        key: 'status_operation_BF',
        value: 'status_operation_BF.label',
        operator: '$eq',
      },
      {
        key: 'status_billing',
        value: 'status_billing.label',
        operator: '$eq',
      },
      {
        key: 'id_yacht.id_attendance.id_user_provision.id',
        value: 'id_user_provision.id',
        operator: '$eq',
      },
      {
        key: 'id_yacht.id_attendance.id_provenence_list.provenence.id',
        value: 'provenance.id',
        operator: '$eq',
      },
      {
        key: 'id_marina.area',
        value: 'area.id',
        operator: '$eq',
      },
    ],
  },
};
